@let panelIndex = $panelIndex();
@let config = $config();

<div class="settings-panel-track" [style.transform]="'translate3d(' + (panelIndex * -100) + '%, 0, 0)'" [style.height.px]="$isCommandPaletteMode() ? $activePageHeight() : null" cdkTrapFocus [cdkTrapFocusAutoCapture]="false">

  <settings-panel-page [title]="config.title" [showClose]="!$isCommandPaletteMode()" [hideHeader]="$isCommandPaletteMode()" [headerCommands]="config.headerCommands ?? []" [footerLeftCommands]="config.footerLeftCommands ?? []" [footerRightCommands]="config.footerRightCommands ?? []" [footerSplitButton]="$footerSplitButton()" (close)="requestClose()">
    <settings-panel-menu [items]="config.items" [search]="config.search" [mode]="$mode()" [renderers]="$rendererMap()" [formGroup]="$formGroup()" [panel]="$panel()" [showErrors]="!$isCommandPaletteMode()" (itemClicked)="onMenuItemClicked($event)" />
  </settings-panel-page>

  @for (panel of $activePanels(); track $index) {
    <settings-panel-page [title]="$stackTitles()[$index]" [showBack]="true" [headerCommands]="panel?.headerCommands ?? []" [footerLeftCommands]="panel?.footerLeftCommands ?? []" [footerRightCommands]="panel?.footerRightCommands ?? []" [footerSplitButton]="$index === $activePanels().length - 1 ? $activeFooterSplitButton() : $safeNavigationMigration(panel?.footerSplitButton)" (back)="navigateBack()">

      @if (panel) {
        @switch (panel.type) {
          @case ('template') {
            <ng-container *ngTemplateOutlet="panel.template"></ng-container>
          }
          @case ('component') {
            <ng-container *ngComponentOutlet="panel.component; injector: resolveEntryInjector(panel); inputs: getComponentInputs(panel)"></ng-container>
          }
          @case ('menu') {
            <settings-panel-menu [items]="panel.items" [search]="panel.search" [mode]="$mode()" [renderers]="$rendererMap()" [formGroup]="$formGroup()" [panel]="$panel()" [showErrors]="!$isCommandPaletteMode()" (itemClicked)="onMenuItemClicked($event)" />
          }
          @case ('picker') {
            <settings-panel-picker [config]="panel.viewConfig" [mode]="$mode()" [active]="$index === $activePanels().length - 1" [formControl]="panel.control" />
          }
          @case ('entityPicker') {
            <settings-panel-entity-picker [config]="panel.viewConfig" [mode]="$mode()" [active]="$index === $activePanels().length - 1" [formControl]="panel.control" />
          }
        }
      }

    </settings-panel-page>
  }

</div>
